

window.currentBanner=0;
window.bannerCount=0;
window.bannerTime=10; // secs

window.updateBannerView=function (opt){
    $(".barraProgreso").css("transition","none");
    $(".barraProgreso").css("width","100%");

    $(".banner").css("display","none");
    if(opt==undefined){
        currentBanner++;
    }else if(opt=="+"){
        stopBanners();
        startBanners();
        currentBanner++;
    }else if(opt=="-"){
        stopBanners();
        startBanners();
        currentBanner--;
    }
    else{
        stopBanners();
        startBanners();
        currentBanner=opt
    }

    if(currentBanner<0){
        currentBanner=bannerCount;
    }else if(currentBanner>bannerCount){
        currentBanner=0;
    }

    $(".banner")[currentBanner].style.display="block";
    $(".btnsBans").removeClass("activeBtn");
    $("#btnBan-"+currentBanner).addClass("activeBtn");
    // console.log($(".banner")[currentBanner].id);
    setTimeout(() => {
        // $(".barraProgreso").css("transition",bannerTime+"s");
        $(".barraProgreso").css("transition","all 10s linear 0.2s");
        $(".barraProgreso").css("width","0%");
    });
}

window.bannersInterval;
$(document).ready(function(){
    bannerCount=$(".banner").length-1;
    $($(".banner")[0]).show();
    $($(".btnsBans")[0]).addClass("activeBtn");
    startBanners();
});

window.startBanners=function(){
    if ($(".listBanners").length>0){
        bannersInterval=setInterval(function(){
            updateBannerView();
        },bannerTime*1000);
    }
}

window.stopBanners=function (){
    clearInterval(bannersInterval);
}
/*
$(".barraProgreso").css("transition","0s");
$(".barraProgreso").css("width","100%");

$(".barraProgreso").css("transition",bannerTime+"s");
$(".barraProgreso").css("width","0%");
*/